import { ctgBackendRequest, authRequest } from "../utils/netRequest";

export class AuthService {
  async login({ phone: { countryCode, phone } }) {
    return await ctgBackendRequest({
      url: "/auth/code",
      method: "post",
      data: {
        countryCode,
        phone,
      },
    });
  }

  async authVerify({ phone, verificationCode, fcmToken }) {
    return await ctgBackendRequest({
      url: "/auth/phone/verify",
      method: "post",
      apiVersion: "v2",
      data: {
        phone,
        verificationCode,
        fcmToken,
      },
    });
  }

  async authAgreeTerms() {
    return await authRequest({
      url: "/profile/agree-terms",
      method: "post",
    });
  }

  async logout() {
    return await authRequest({
      url: "/auth/signout",
      method: "post",
    });
  }

  async auth(countryCode, phone, fcmToken) {
    return await authRequest({
      url: "/auth",
      method: "post",
      apiVersion: "v2",
      data: {
        phone: {
          phone: phone,
          countryCode: {
            id: countryCode,
          },
        },
        fcmToken,
      },
    });
  }

}

export default new AuthService();


